





import {Vue, Component, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import SingleAndMultiDashboardPage from '@/components/Views/Dashboard/SingleAndMultiDashboardPage.vue';
import {getStoreSettings, nil, stripeKeys, testStripeKeys} from '@/common';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
@Component({
    components: {
    },
})
export default class ForwardToStripe extends Mixins(SingleAndMultiDashboardPage, GlobalAlertMixin) {
    public feathersModel = this.$FeathersVuex.Order;
    public routeParameter = 'order';
    public redirectOnMulti = true;
    @Watch('itemBeingViewed')
    public onViewingItemChanged(value: any, oldValue: any) {
        console.log(value);
        if (!nil(value.stripeSessionId)) {
            this.proceed(value);
        }
    }
    public async proceed(orderModel) {
        const settings = await getStoreSettings(this.$FeathersVuex.Setting);
        const stripe = (window as any).Stripe(settings.testMode ? testStripeKeys.public : stripeKeys.public);
        const checkout = await stripe.redirectToCheckout({sessionId: orderModel.stripeSessionId});
    }
}
